import axios from 'axios';

export const toBase64ImageUrl = async (imgUrl: string): Promise<string> => {
	const res = await axios.get(imgUrl, { responseType: 'arraybuffer' });

	// browser-native base64, no Buffer
	const bytes = new Uint8Array(res.data);
	let binary = '';
	for (let i = 0; i < bytes.length; i++) {
		binary += String.fromCharCode(bytes[i]);
	}
	const base64 = btoa(binary);

	return `data:image/png;base64,${base64}`;
};
